var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCategoriesState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 250,
    viewBox: "0 0 476 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_48122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.616 122.808C326.616 144.16 311.295 173.198 286.397 196.927C261.517 220.638 227.173 238.95 189.269 238.95C170.31 238.95 155.433 234.848 143.776 227.721C132.12 220.594 123.649 210.421 117.532 198.225C105.288 173.812 102.5 141.336 102.5 109.134C102.5 76.9137 106.441 57.5092 119.692 46.0949C126.322 40.3837 135.328 36.6332 147.457 34.3139C159.588 31.9943 174.806 31.1129 193.829 31.1129C231.789 31.1129 265.006 43.3545 288.724 60.9519C312.457 78.5604 326.616 101.477 326.616 122.808Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64 165.48C299.64 183.761 286.486 208.643 265.093 228.983C243.718 249.305 214.215 264.997 181.659 264.997C165.374 264.997 152.6 261.482 142.594 255.378C132.588 249.275 125.316 240.563 120.064 230.116C109.548 209.198 107.151 181.367 107.151 153.756C107.151 126.127 110.54 109.521 121.903 99.7565C127.589 94.8702 135.316 91.6578 145.735 89.6704C156.155 87.6826 169.23 86.9269 185.579 86.9269C218.19 86.9269 246.726 97.419 267.1 112.499C287.488 127.59 299.64 147.222 299.64 165.48Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.895 103.047C362.895 112.836 358.645 125.822 350.894 139.825C343.151 153.817 331.939 168.777 318.081 182.504C290.356 209.967 252.097 232.439 209.883 232.439C188.761 232.439 172.184 227.869 159.191 219.925C146.2 211.982 136.76 200.645 129.944 187.057C116.302 159.857 113.198 123.681 113.198 87.8204C113.198 51.9414 117.584 30.3073 132.363 17.5779C139.757 11.2091 149.797 7.02974 163.31 4.44598C176.824 1.86186 193.776 0.880371 214.962 0.880371C257.229 0.880371 294.231 16.5907 320.664 37.2415C333.881 47.5667 344.446 59.12 351.703 70.549C358.964 81.9838 362.895 93.263 362.895 103.047Z",
    stroke: "#FAFAFA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1496_48122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.9905,
    y: 53.1267,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7005 82.3695C93.6054 82.2784 93.4932 82.2071 93.3705 82.1595C93.127 82.0595 92.8539 82.0595 92.6105 82.1595C92.4877 82.2071 92.3756 82.2784 92.2805 82.3695C92.1894 82.4646 92.1181 82.5767 92.0705 82.6995C91.9939 82.8816 91.973 83.0823 92.0103 83.2763C92.0477 83.4703 92.1417 83.6488 92.2805 83.7895C92.3777 83.8778 92.4893 83.9488 92.6105 83.9995C92.7302 84.0524 92.8596 84.0797 92.9905 84.0797C93.1213 84.0797 93.2508 84.0524 93.3705 83.9995C93.4917 83.9488 93.6033 83.8778 93.7005 83.7895C93.8392 83.6488 93.9332 83.4703 93.9706 83.2763C94.008 83.0823 93.987 82.8816 93.9105 82.6995C93.8629 82.5767 93.7915 82.4646 93.7005 82.3695ZM96.9905 74.0795H110.99C111.256 74.0795 111.51 73.9741 111.698 73.7866C111.885 73.599 111.99 73.3447 111.99 73.0795C111.99 72.8143 111.885 72.5599 111.698 72.3724C111.51 72.1848 111.256 72.0795 110.99 72.0795H96.9905C96.7253 72.0795 96.4709 72.1848 96.2834 72.3724C96.0958 72.5599 95.9905 72.8143 95.9905 73.0795C95.9905 73.3447 96.0958 73.599 96.2834 73.7866C96.4709 73.9741 96.7253 74.0795 96.9905 74.0795ZM93.7005 77.3695C93.5598 77.2307 93.3813 77.1367 93.1873 77.0993C92.9933 77.062 92.7926 77.0829 92.6105 77.1595C92.4893 77.2101 92.3777 77.2811 92.2805 77.3695C92.1894 77.4646 92.1181 77.5767 92.0705 77.6995C92.0176 77.8192 91.9902 77.9486 91.9902 78.0795C91.9902 78.2103 92.0176 78.3398 92.0705 78.4595C92.1211 78.5807 92.1921 78.6923 92.2805 78.7895C92.3777 78.8778 92.4893 78.9488 92.6105 78.9995C92.7302 79.0524 92.8596 79.0797 92.9905 79.0797C93.1213 79.0797 93.2508 79.0524 93.3705 78.9995C93.4917 78.9488 93.6033 78.8778 93.7005 78.7895C93.7888 78.6923 93.8598 78.5807 93.9105 78.4595C93.9634 78.3398 93.9907 78.2103 93.9907 78.0795C93.9907 77.9486 93.9634 77.8192 93.9105 77.6995C93.8629 77.5767 93.7915 77.4646 93.7005 77.3695ZM110.99 77.0795H96.9905C96.7253 77.0795 96.4709 77.1848 96.2834 77.3724C96.0958 77.5599 95.9905 77.8143 95.9905 78.0795C95.9905 78.3447 96.0958 78.599 96.2834 78.7866C96.4709 78.9741 96.7253 79.0795 96.9905 79.0795H110.99C111.256 79.0795 111.51 78.9741 111.698 78.7866C111.885 78.599 111.99 78.3447 111.99 78.0795C111.99 77.8143 111.885 77.5599 111.698 77.3724C111.51 77.1848 111.256 77.0795 110.99 77.0795ZM93.7005 72.3695C93.6054 72.2784 93.4932 72.2071 93.3705 72.1595C93.1884 72.0829 92.9876 72.062 92.7937 72.0993C92.5997 72.1367 92.4211 72.2307 92.2805 72.3695C92.1921 72.4667 92.1211 72.5783 92.0705 72.6995C92.0176 72.8192 91.9902 72.9486 91.9902 73.0795C91.9902 73.2103 92.0176 73.3398 92.0705 73.4595C92.1211 73.5807 92.1921 73.6923 92.2805 73.7895C92.3777 73.8778 92.4893 73.9488 92.6105 73.9995C92.7926 74.076 92.9933 74.097 93.1873 74.0596C93.3813 74.0222 93.5598 73.9282 93.7005 73.7895C93.7888 73.6923 93.8598 73.5807 93.9105 73.4595C93.9634 73.3398 93.9907 73.2103 93.9907 73.0795C93.9907 72.9486 93.9634 72.8192 93.9105 72.6995C93.8598 72.5783 93.7888 72.4667 93.7005 72.3695ZM110.99 82.0795H96.9905C96.7253 82.0795 96.4709 82.1848 96.2834 82.3724C96.0958 82.5599 95.9905 82.8143 95.9905 83.0795C95.9905 83.3447 96.0958 83.599 96.2834 83.7866C96.4709 83.9741 96.7253 84.0795 96.9905 84.0795H110.99C111.256 84.0795 111.51 83.9741 111.698 83.7866C111.885 83.599 111.99 83.3447 111.99 83.0795C111.99 82.8143 111.885 82.5599 111.698 82.3724C111.51 82.1848 111.256 82.0795 110.99 82.0795Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.99,
    y: 72.0795,
    width: 173.516,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1496_48122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.984,
    y: 124.42,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.694 153.663C207.599 153.572 207.487 153.501 207.364 153.453C207.121 153.353 206.848 153.353 206.604 153.453C206.481 153.501 206.369 153.572 206.274 153.663C206.183 153.758 206.112 153.87 206.064 153.993C205.988 154.175 205.967 154.376 206.004 154.57C206.041 154.764 206.135 154.943 206.274 155.083C206.371 155.171 206.483 155.243 206.604 155.293C206.724 155.346 206.853 155.373 206.984 155.373C207.115 155.373 207.244 155.346 207.364 155.293C207.485 155.243 207.597 155.171 207.694 155.083C207.833 154.943 207.927 154.764 207.964 154.57C208.002 154.376 207.981 154.175 207.904 153.993C207.857 153.87 207.785 153.758 207.694 153.663ZM210.984 145.373H224.984C225.249 145.373 225.504 145.268 225.691 145.08C225.879 144.893 225.984 144.638 225.984 144.373C225.984 144.108 225.879 143.854 225.691 143.666C225.504 143.479 225.249 143.373 224.984 143.373H210.984C210.719 143.373 210.465 143.479 210.277 143.666C210.089 143.854 209.984 144.108 209.984 144.373C209.984 144.638 210.089 144.893 210.277 145.08C210.465 145.268 210.719 145.373 210.984 145.373ZM207.694 148.663C207.553 148.524 207.375 148.43 207.181 148.393C206.987 148.356 206.786 148.377 206.604 148.453C206.483 148.504 206.371 148.575 206.274 148.663C206.183 148.758 206.112 148.87 206.064 148.993C206.011 149.113 205.984 149.242 205.984 149.373C205.984 149.504 206.011 149.633 206.064 149.753C206.115 149.874 206.186 149.986 206.274 150.083C206.371 150.171 206.483 150.243 206.604 150.293C206.724 150.346 206.853 150.373 206.984 150.373C207.115 150.373 207.244 150.346 207.364 150.293C207.485 150.243 207.597 150.171 207.694 150.083C207.782 149.986 207.853 149.874 207.904 149.753C207.957 149.633 207.984 149.504 207.984 149.373C207.984 149.242 207.957 149.113 207.904 148.993C207.857 148.87 207.785 148.758 207.694 148.663ZM224.984 148.373H210.984C210.719 148.373 210.465 148.479 210.277 148.666C210.089 148.854 209.984 149.108 209.984 149.373C209.984 149.638 210.089 149.893 210.277 150.08C210.465 150.268 210.719 150.373 210.984 150.373H224.984C225.249 150.373 225.504 150.268 225.691 150.08C225.879 149.893 225.984 149.638 225.984 149.373C225.984 149.108 225.879 148.854 225.691 148.666C225.504 148.479 225.249 148.373 224.984 148.373ZM207.694 143.663C207.599 143.572 207.487 143.501 207.364 143.453C207.182 143.377 206.981 143.356 206.787 143.393C206.593 143.43 206.415 143.524 206.274 143.663C206.186 143.76 206.115 143.872 206.064 143.993C206.011 144.113 205.984 144.242 205.984 144.373C205.984 144.504 206.011 144.633 206.064 144.753C206.115 144.874 206.186 144.986 206.274 145.083C206.371 145.171 206.483 145.243 206.604 145.293C206.786 145.37 206.987 145.391 207.181 145.353C207.375 145.316 207.553 145.222 207.694 145.083C207.782 144.986 207.853 144.874 207.904 144.753C207.957 144.633 207.984 144.504 207.984 144.373C207.984 144.242 207.957 144.113 207.904 143.993C207.853 143.872 207.782 143.76 207.694 143.663ZM224.984 153.373H210.984C210.719 153.373 210.465 153.479 210.277 153.666C210.089 153.854 209.984 154.108 209.984 154.373C209.984 154.638 210.089 154.893 210.277 155.08C210.465 155.268 210.719 155.373 210.984 155.373H224.984C225.249 155.373 225.504 155.268 225.691 155.08C225.879 154.893 225.984 154.638 225.984 154.373C225.984 154.108 225.879 153.854 225.691 153.666C225.504 153.479 225.249 153.373 224.984 153.373Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.984,
    y: 143.373,
    width: 173.516,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1496_48122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 195.714,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.21 224.957C31.1149 224.866 31.0027 224.794 30.88 224.747C30.6365 224.647 30.3634 224.647 30.12 224.747C29.9972 224.794 29.8851 224.866 29.79 224.957C29.6989 225.052 29.6276 225.164 29.58 225.287C29.5034 225.469 29.4825 225.67 29.5199 225.864C29.5572 226.058 29.6512 226.236 29.79 226.377C29.8872 226.465 29.9988 226.536 30.12 226.587C30.2397 226.64 30.3691 226.667 30.5 226.667C30.6309 226.667 30.7603 226.64 30.88 226.587C31.0012 226.536 31.1128 226.465 31.21 226.377C31.3487 226.236 31.4427 226.058 31.4801 225.864C31.5175 225.67 31.4966 225.469 31.42 225.287C31.3724 225.164 31.301 225.052 31.21 224.957ZM34.5 216.667H48.5C48.7652 216.667 49.0196 216.561 49.2071 216.374C49.3946 216.186 49.5 215.932 49.5 215.667C49.5 215.402 49.3946 215.147 49.2071 214.96C49.0196 214.772 48.7652 214.667 48.5 214.667H34.5C34.2348 214.667 33.9804 214.772 33.7929 214.96C33.6053 215.147 33.5 215.402 33.5 215.667C33.5 215.932 33.6053 216.186 33.7929 216.374C33.9804 216.561 34.2348 216.667 34.5 216.667ZM31.21 219.957C31.0694 219.818 30.8908 219.724 30.6968 219.687C30.5028 219.649 30.3021 219.67 30.12 219.747C29.9988 219.797 29.8872 219.868 29.79 219.957C29.6989 220.052 29.6276 220.164 29.58 220.287C29.5271 220.406 29.4998 220.536 29.4998 220.667C29.4998 220.798 29.5271 220.927 29.58 221.047C29.6306 221.168 29.7017 221.28 29.79 221.377C29.8872 221.465 29.9988 221.536 30.12 221.587C30.2397 221.64 30.3691 221.667 30.5 221.667C30.6309 221.667 30.7603 221.64 30.88 221.587C31.0012 221.536 31.1128 221.465 31.21 221.377C31.2983 221.28 31.3693 221.168 31.42 221.047C31.4729 220.927 31.5002 220.798 31.5002 220.667C31.5002 220.536 31.4729 220.406 31.42 220.287C31.3724 220.164 31.301 220.052 31.21 219.957ZM48.5 219.667H34.5C34.2348 219.667 33.9804 219.772 33.7929 219.96C33.6053 220.147 33.5 220.402 33.5 220.667C33.5 220.932 33.6053 221.186 33.7929 221.374C33.9804 221.561 34.2348 221.667 34.5 221.667H48.5C48.7652 221.667 49.0196 221.561 49.2071 221.374C49.3946 221.186 49.5 220.932 49.5 220.667C49.5 220.402 49.3946 220.147 49.2071 219.96C49.0196 219.772 48.7652 219.667 48.5 219.667ZM31.21 214.957C31.1149 214.866 31.0027 214.794 30.88 214.747C30.6979 214.67 30.4972 214.649 30.3032 214.687C30.1092 214.724 29.9306 214.818 29.79 214.957C29.7017 215.054 29.6306 215.166 29.58 215.287C29.5271 215.406 29.4998 215.536 29.4998 215.667C29.4998 215.798 29.5271 215.927 29.58 216.047C29.6306 216.168 29.7017 216.28 29.79 216.377C29.8872 216.465 29.9988 216.536 30.12 216.587C30.3021 216.663 30.5028 216.684 30.6968 216.647C30.8908 216.61 31.0694 216.516 31.21 216.377C31.2983 216.28 31.3693 216.168 31.42 216.047C31.4729 215.927 31.5002 215.798 31.5002 215.667C31.5002 215.536 31.4729 215.406 31.42 215.287C31.3693 215.166 31.2983 215.054 31.21 214.957ZM48.5 224.667H34.5C34.2348 224.667 33.9804 224.772 33.7929 224.96C33.6053 225.147 33.5 225.402 33.5 225.667C33.5 225.932 33.6053 226.186 33.7929 226.374C33.9804 226.561 34.2348 226.667 34.5 226.667H48.5C48.7652 226.667 49.0196 226.561 49.2071 226.374C49.3946 226.186 49.5 225.932 49.5 225.667C49.5 225.402 49.3946 225.147 49.2071 224.96C49.0196 224.772 48.7652 224.667 48.5 224.667Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 214.667,
    width: 173.516,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1496_48122",
    x: 62.9905,
    y: 51.1267,
    width: 263.516,
    height: 55.9055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1496_48122",
    result: "effect2_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1496_48122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1496_48122",
    x: 141.984,
    y: 111.42,
    width: 333.516,
    height: 125.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1496_48122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1496_48122",
    x: 0.5,
    y: 193.714,
    width: 263.516,
    height: 55.9055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1496_48122",
    result: "effect2_dropShadow_1496_48122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1496_48122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_48122"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    rx: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategoriesState);
export default __webpack_public_path__ + "static/media/empty_categories_state.1d55b55bebad46b4fe2e0bcec6122c24.svg";
export { ForwardRef as ReactComponent };